(function () {
  var config = window.RelifeMarketPicker || {};
  var allowed = ['US', 'CA', 'GB'];
  var seenKey = 'relifeMarketChoiceSeenV1';
  var choiceKey = 'relifeMarketChoiceV1';
  var current = String((config.currentCountry || {}).isoCode || '').toUpperCase();
  var countries = Array.isArray(config.availableCountries) ? config.availableCountries : [];

  function remember(country) {
    try {
      window.localStorage.setItem(seenKey, '1');
      if (country) window.localStorage.setItem(choiceKey, country);
    } catch (error) {}
  }

  function buildPopup() {
    if (!document.body || window.Shopify && window.Shopify.designMode) return;
    if (document.querySelector('[data-relife-market-picker]')) return;
    try {
      if (window.localStorage.getItem(seenKey) === '1') return;
    } catch (error) {}

    var options = allowed.map(function (code) {
      return countries.find(function (country) { return country.isoCode === code; });
    }).filter(Boolean);
    if (options.length < 2) return;

    var dialog = document.createElement('dialog');
    if (typeof dialog.showModal !== 'function') return;
    dialog.className = 'rmk-dialog';
    dialog.setAttribute('data-relife-market-picker', '');
    dialog.setAttribute('aria-labelledby', 'rmk-title');
    dialog.innerHTML = '<button type="button" class="rmk-close" aria-label="Close region selector">&times;</button>' +
      '<h2 id="rmk-title">Choose your region</h2>' +
      '<form method="post" action="/localization">' +
      '<input type="hidden" name="form_type" value="localization">' +
      '<input type="hidden" name="_method" value="put">' +
      '<input type="hidden" name="return_to">' +
      '<label class="rmk-label" for="rmk-country">Country / region</label>' +
      '<select id="rmk-country" name="country_code"></select>' +
      '<button type="submit" class="rmk-continue">Continue</button></form>';

    var form = dialog.querySelector('form');
    var select = dialog.querySelector('select');
    var close = dialog.querySelector('.rmk-close');
    options.forEach(function (country) {
      var option = document.createElement('option');
      option.value = country.isoCode;
      option.textContent = country.name + ' (' + country.currency + ')';
      select.appendChild(option);
    });
    if (options.some(function (country) { return country.isoCode === current; })) select.value = current;
    form.elements.return_to.value = window.location.pathname + window.location.search + window.location.hash;

    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () {
      remember(current);
      document.documentElement.classList.remove('rmk-modal-open');
    });
    dialog.addEventListener('click', function (event) {
      var rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    form.addEventListener('submit', function (event) {
      if (!options.some(function (country) { return country.isoCode === select.value; })) {
        event.preventDefault();
        return;
      }
      remember(select.value);
      if (select.value === current) {
        event.preventDefault();
        dialog.close();
      }
    });

    document.body.appendChild(dialog);
    dialog.showModal();
    document.documentElement.classList.add('rmk-modal-open');
    select.focus();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildPopup);
  else buildPopup();
})();
